import { Map } from 'immutable';

import { materialsToString } from '../../../tags';

import ATTRIBUTE from '../../../../constants/attributes';

export function materials({ channel, preview }) {
  return {
    payload: Map({
      type: preview.getIn([ATTRIBUTE.MATERIALS, 'operation']),
      value: materialsToString({ channel, materials: preview.getIn([ATTRIBUTE.MATERIALS, ATTRIBUTE.MATERIALS]) }),
    }),
  };
}
